export default {"src":"/kaimono/_next/static/media/wamazing_play_tokyu.703afdd9.svg","height":61,"width":797};